import types from 'dashboard/store/mutation-types';
import {
  captureProfileSession,
  captureProfileRead,
  completeProfileRead,
} from './profileReads';

export const startProfileMutation = context => {
  const sameSession = captureProfileSession(context);
  const isCurrent = captureProfileRead(context);
  return {
    isCurrent,
    sameSession,
    async apply(user) {
      if (isCurrent()) {
        context.commit(types.SET_CURRENT_USER, user);
        completeProfileRead(context);
      } else if (sameSession()) {
        // The write succeeded after a newer read. Fetch the resulting state
        // without publishing the mutation's potentially obsolete permissions.
        await context.dispatch('validityCheck');
      }
    },
  };
};
